import httpClient from '@src/services/http.service'

export const state = {
  notices: [],
  articles: [],
  pageData: [],
  error: '',
}

export const actions = {
  init: ({ commit }) => {
    Promise.all([httpClient.get('pages/5fe3146bc1478823bac06381'), httpClient.get('/news'), httpClient.get('/notice')])
    .then(([pageResponse, articlesResponse, noticesResponse]) => {
      commit('SET_PAGE_DATA', pageResponse.data)
      commit('SET_ARTICLES', articlesResponse.data)
      commit('SET_NOTICE', noticesResponse.data)
    })
    .catch(error => {
      commit('SET_ERROR', error.message)
    })
  }
}

export const mutations = {
  SET_NOTICE: (state, notices) => {
    state.notices = notices
  },
  SET_ARTICLES: (state, articles) => {
    state.articles = articles
  },
  SET_PAGE_DATA: (state, pageData) => {
    state.pageData = pageData
  },
  SET_ERROR: (state, error) => {
    state.error = error
  },
}

export const getters = {
  pageData: state => state.pageData,
  noticeList: state => state.notices,
  attractionNotice: state => id => state.notices.find(notice => notice.attraction === id),
  newsList: state => state.articles,
  homeNewsList: state => state.articles.filter(article => article.displayOnHomePage),
  getArticle: state => url => state.articles.find(article => article.url === url),

  nextArticle: state => article => {
    const attractionOrderNum = state.articles.indexOf(article)
    if (article._id !== state.articles[state.articles.length - 1]._id && attractionOrderNum >= 0) {
      return state.articles[attractionOrderNum + 1].url
    }
  },

  previousArticle: state => article => {
    const attractionOrderNum = state.articles.indexOf(article)
    if (attractionOrderNum > 0) {
      return state.articles[attractionOrderNum - 1].url
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
